var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-column justify-center",staticStyle:{"position":"relative"},attrs:{"color":"transparent","elevation":"0","tile":""}},[(_vm.graphIsReady)?_c('apex-chart',{attrs:{"options":_vm.options,"series":_vm.series,"type":_vm.info.length < 16 ? 'bar' : 'area',"height":"350","width":"100%"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }